// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as React from "react";
import { Button, Header, Icon, Modal, Segment } from "semantic-ui-react";
import DashboardWidgetList from "./DashboardWidgetList";
import { getClassName } from "../../../components/utils/className";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardWidgetPlaceholder = props => {
  const {
    onChange
  } = props;
  const [open, setOpen] = React.useState(false);
  const [selection, setSelection] = React.useState({
    identifiant: null
  });
  const handleOpen = React.useCallback(() => {
    setOpen(true);
  }, []);
  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);
  const handleCancel = React.useCallback(() => {
    setOpen(false);
  }, []);
  const handleSave = React.useCallback(() => {
    onChange?.(selection);
    setOpen(false);
  }, [selection]);
  const handleSelect = React.useCallback(data => {
    setSelection(data);
  }, []);
  const trigger = React.useMemo(() => /*#__PURE__*/_jsx(Segment, {
    className: getClassName("dashboard-widget", "placeholder"),
    children: /*#__PURE__*/_jsxs(Header, {
      as: "h4",
      icon: true,
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(Header.Content, {
        children: "Ajouter une vue"
      }), /*#__PURE__*/_jsx(Icon, {
        name: "share",
        rotated: "clockwise",
        size: "large"
      })]
    })
  }), []);
  const content = React.useMemo(() => /*#__PURE__*/_jsx(DashboardWidgetList, {
    onSelectionChange: handleSelect
  }), [handleSelect]);
  return /*#__PURE__*/_jsxs(Modal, {
    className: "close-icon-inside",
    trigger: trigger,
    onClose: handleClose,
    onOpen: handleOpen,
    open: open,
    size: "tiny",
    closeIcon: true,
    "data-sentry-element": "Modal",
    "data-sentry-component": "DashboardWidgetPlaceholder",
    "data-sentry-source-file": "DashboardWidgetPlaceholder.tsx",
    children: [/*#__PURE__*/_jsxs(Modal.Header, {
      as: Segment,
      inverted: true,
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "DashboardWidgetPlaceholder.tsx",
      children: [/*#__PURE__*/_jsx(Icon, {
        name: "dashboard",
        "data-sentry-element": "Icon",
        "data-sentry-source-file": "DashboardWidgetPlaceholder.tsx"
      }), "Vue"]
    }), /*#__PURE__*/_jsx(Modal.Content, {
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "DashboardWidgetPlaceholder.tsx",
      children: content
    }), /*#__PURE__*/_jsxs(Modal.Actions, {
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "DashboardWidgetPlaceholder.tsx",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: handleCancel,
        content: "Annuler",
        basic: true,
        "data-sentry-element": "Button",
        "data-sentry-source-file": "DashboardWidgetPlaceholder.tsx"
      }), /*#__PURE__*/_jsx(Button, {
        onClick: handleSave,
        content: "S\xE9lectionner",
        labelPosition: "left",
        icon: "checkmark",
        disabled: !selection?.identifiant,
        positive: true,
        "data-sentry-element": "Button",
        "data-sentry-source-file": "DashboardWidgetPlaceholder.tsx"
      })]
    })]
  });
};
export default DashboardWidgetPlaceholder;